import React from 'react';
import { LockOutlined, PhoneOutlined, UserOutlined, WarningOutlined } from '@ant-design/icons';
import { Main } from '../container/styled';
import Heading from '../components/ui/heading/heading';

const PermissionDenied = ({ message, title = 'Permission Denied', locked = true, details = null }) => {
    const reason = details?.lock_message || message;
    const contactPerson = details?.contact_person;
    const contactMobile = details?.contact_mobile;
    const displayReason = reason || 'Sorry, you are locked out.';

    return (
        <Main>
            <div style={{ minHeight: 'calc(100vh - 180px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
                <div style={{ width: '100%', maxWidth: 720, background: '#fff', border: '1px solid #e6edf5', borderRadius: 12, boxShadow: '0 16px 40px rgba(39, 88, 155, 0.12)', overflow: 'hidden' }}>
                    <div style={{ height: 6, background: '#f52626' }} />
                    <div style={{ padding: '32px 36px', textAlign: 'center' }}>
                        <div style={{ color: "#f52626", display: 'flex',alignItems: 'center', justifyContent: 'center', marginBottom: 12, fontSize: 34, gap:10 }}>
                            {locked ? <LockOutlined /> : <WarningOutlined />}
                            <Heading as="h3" style={{ marginBottom: 0, color: '#f52626',fontSize: 24, fontWeight: 600 }}>
                                {title}
                            </Heading>
                        </div>


                        <div style={{ textAlign: 'left', background: '#f8fafc', border: '1px solid #f52626', borderRadius: 10, padding: '18px 20px', marginTop: 20 }}>
                            <p style={{ margin: 0, color: '#344054', lineHeight: 1.7 }}>
                                <strong style={{ color: '#1f2937' }}>Reason :</strong> {displayReason}
                            </p>
                        </div>

                        {(contactPerson || contactMobile) && (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginTop: 16, textAlign: 'left' }}>
                                {contactPerson && (
                                    <div style={{ border: '1px solid #edf2f7', borderRadius: 10, padding: '14px 16px', background: '#fff' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                            <UserOutlined style={{ color: '#27589b', fontSize: 18 }} />
                                            <div>
                                                <div style={{ color: '#667085', fontSize: 12 }}>Contact Person</div>
                                                <strong style={{ color: '#1f2937' }}>{contactPerson}</strong>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {contactMobile && (
                                    <div style={{ border: '1px solid #edf2f7', borderRadius: 10, padding: '14px 16px', background: '#fff' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                            <PhoneOutlined style={{ color: '#27589b', fontSize: 18 }} />
                                            <div>
                                                <div style={{ color: '#667085', fontSize: 12 }}>Contact Mobile</div>
                                                <strong style={{ color: '#1f2937' }}>{contactMobile}</strong>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Main>
    );
};

export default PermissionDenied;
